/* BloomingFlower Little Moments: scoped progressive enhancement. */
(() => {
  function init(root = document) {
    root.querySelectorAll('[data-bfl-section]').forEach(section => {
      if (section.dataset.bflReady) return;
      section.dataset.bflReady = 'true';
      const menu = section.querySelector('[data-bfl-menu]');
      if (menu) {
        const nav = section.querySelector('.main-nav');
        const categories = section.querySelector('[data-bfl-categories]');
        categories?.addEventListener('keydown', e => {
          if (e.key === 'Escape' && categories.open) {
            e.preventDefault();
            e.stopPropagation();
            categories.open = false;
            categories.querySelector('summary')?.focus();
          }
        });
        categories?.addEventListener('focusout', e => {
          if (e.relatedTarget && !categories.contains(e.relatedTarget)) categories.open = false;
        });
        const setMenu = open => {
          menu.setAttribute('aria-expanded', String(open));
          menu.textContent = open ? menu.dataset.closeLabel : menu.dataset.openLabel;
          nav?.classList.toggle('open', open);
          if (!open && categories) categories.open = false;
        };
        menu.addEventListener('click', () => setMenu(menu.getAttribute('aria-expanded') !== 'true'));
        section.addEventListener('keydown', e => {
          if (e.key === 'Escape' && menu.getAttribute('aria-expanded') === 'true' && !section.querySelector('dialog[open]')) {
            e.preventDefault();
            setMenu(false);
            menu.focus();
          }
        });
        nav?.addEventListener('click', e => {
          if (e.target.closest('a')) setMenu(false);
        });
        const mobile = matchMedia('(max-width:760px)');
        mobile.addEventListener('change', () => {
          if (!section.isConnected) return;
          const wasInMenu = nav?.contains(document.activeElement);
          setMenu(false);
          if (mobile.matches && wasInMenu) menu.focus();
        });
      }
      const dialog = section.querySelector('[data-bfl-search]');
      if (dialog) {
        section.querySelectorAll('[data-bfl-open-search]').forEach(b => b.addEventListener('click', () => dialog.showModal()));
        dialog.querySelector('[data-bfl-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', e => {
          if (e.target !== dialog) return;
          const r = dialog.getBoundingClientRect();
          if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
        });
      }
      const buttons = [...section.querySelectorAll('[data-bfl-tab]')];
      function select(button) {
        buttons.forEach(b => {
          const selected = b === button;
          b.setAttribute('aria-selected', String(selected));
          b.tabIndex = selected ? 0 : -1;
        });
        section.querySelectorAll('[data-bfl-panel]').forEach(panel => {
          panel.hidden = panel.dataset.bflPanel !== button.dataset.bflTab;
        });
      }
      buttons.forEach((b, i) => {
        b.addEventListener('click', () => select(b));
        b.addEventListener('keydown', e => {
          let n;
          if (e.key === 'ArrowRight') n = (i + 1) % buttons.length;
          else if (e.key === 'ArrowLeft') n = (i - 1 + buttons.length) % buttons.length;
          else if (e.key === 'Home') n = 0;
          else if (e.key === 'End') n = buttons.length - 1;
          else return;
          e.preventDefault(); select(buttons[n]); buttons[n].focus();
        });
      });
    });
  }
  document.addEventListener('click', e => {
    document.querySelectorAll('[data-bfl-categories][open]').forEach(menu => {
      if (!menu.contains(e.target)) menu.open = false;
    });
  });
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:block:select', e => {
    const panel = e.target.closest('[data-bfl-panel]');
    if (!panel) return;
    const root = panel.closest('[data-bfl-section]');
    [...root.querySelectorAll('[data-bfl-tab]')].find(b => b.dataset.bflTab === panel.dataset.bflPanel)?.click();
  });
  function refreshCartCount() {
    const base = window.Shopify?.routes?.root || '/';
    fetch(base + 'cart.js', {headers: {Accept: 'application/json'}})
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(cart => document.querySelectorAll('[data-bfl-cart-count]').forEach(el => {
        el.textContent = String(cart.item_count);
        const link = el.closest('[data-bfl-cart-label]');
        if (link) link.setAttribute('aria-label', link.dataset.bflCartLabel + ': ' + cart.item_count);
      }))
      .catch(() => {});
  }
  window.addEventListener('pageshow', e => { if (e.persisted) refreshCartCount(); });
  ['cart:update', 'cart:updated', 'cart:change', 'cart:refresh', 'cart:add'].forEach(type => document.addEventListener(type, refreshCartCount));
})();
